<template>
  <div class="content">
    <div class="el-row">
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">ICCID：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.iccid}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">MSISDN：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.msisdn}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">姓名：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.realName}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">身份证号码：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.idCard}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">  
        <div class="el-form-item el-form-item--medium"> 
          <label class="el-form-item__label" style="width: 120px;">手机号：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.phone}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">认证状态：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.status}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">  
        <div class="el-form-item el-form-item--medium"> 
          <label class="el-form-item__label" style="width: 120px;">创建时间：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.createTime}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">  
        <div class="el-form-item el-form-item--medium"> 
          <label class="el-form-item__label" style="width: 120px;">更新时间：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">{{data.createTime}}</div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">封面：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">
            <viewer :images="signImages1"> 
              <img class="reg-img" v-for="(src,index) in signImages1" :src="src" :key="index"/>
            </viewer>
          </div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">背面：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">
            <viewer :images="signImages2">
              <img class="reg-img" v-for="(src,index) in signImages2" :src="src" :key="index"/>
            </viewer>
          </div>
        </div>
      </div>
      <div class="el-col el-col-12">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">人像：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">
            <viewer :images="signImages3">
              <img class="reg-img" v-for="(src,index) in signImages3" :src="src" :key="index"/>
            </viewer>
          </div>
        </div>
      </div>
      <div class="el-col el-col-24">
        <div class="el-form-item el-form-item--medium">
          <label class="el-form-item__label" style="width: 120px;">备注：</label>
          <div class="el-form-item__content" style="margin-left: 120px;">
            <div class="el-textarea el-input--medium" style="width: 35%;">
              <textarea
                autocomplete="off"
                rows="5"
                class="el-textarea__inner"
                style="min-height: 33px;"
                v-model="input"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="left" style="padding-left:120px;padding-bottom:30px;padding-top:40px;">
      <el-button type="primary" size="medium" @click="boot()" v-hasPermi="['authentication:card:audit']" >审核通过</el-button>
      <el-button type="primary" size="medium" @click="turnoff()" class="el-button--danger" v-hasPermi="['authentication:card:audit']" >审核不通过</el-button>
    </div>
  </div>
</template>
<script>
import { getCertRecord } from "@/api/api.js"; //实名列表
import { changeCertRecordStatus } from "@/api/api.js"; //更改卡实名状态
export default {
  data() {
    return {
      data: {},
      url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/image/',
      input: "",
      signImages1:[],
      signImages2:[],
      signImages3:[],
      id:this.$route.params && this.$route.params.id
    };
  },
  computed: {},
  methods: {
    transferOrderType(status) {
      let obj = {
        1: "待审核 ",
        2: "已审核",
        3: "未通过",
      };
      return obj[status];
    },
    // 获取列表
    initData() {
      getCertRecord({id:this.id}).then(res => {
        if (res.data.code == 200) {
          this.data = res.data.data;
          this.data.status = this.transferOrderType(res.data.data.status);
          this.input = res.data.data.remark;
          this.signImages1.push(this.url + res.data.data.headImg);
          this.signImages2.push(this.url + res.data.data.backImg);
          this.signImages3.push(this.url + res.data.data.peopleImg);
        }
      })
    },
    // 审核通过
    boot() {
      let params = {
        id:this.id,
        status:'2',
        remark:this.input
      };
      changeCertRecordStatus(params).then(res =>{
        if (res.data.code == 200) {
          this.$message({
            message: '审核通过',
            type: 'success'
          });
          this.$router.push({ path: `/authentication/auths`});
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 审核不通过
    turnoff() {
      if (!this.input) return this.$message.error("审核不通过请输入备注内容");
      let params = {
        id:this.id,
        status:'3',
        remark:this.input
      };
      changeCertRecordStatus(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.error('审核不通过');
          this.$router.push({ path: `/authentication/auths`});
        }
      })
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    
  }
};
</script>
<style scoped lang="less">
.reg-img{
  max-width: 300px;
  max-height: 300px;
}
.el-form-item__content{
  color: #1890ff;
}
</style>
